import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IToolAccessConditions } from 'clickNgo/entities/contactFlag'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IToolAccessPartnerFlagsView } from 'clickNgo/models/crud/views'
import { Logic, Operator } from 'core-components/types/index'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

export const fetchToolAccessConditions = async (partnerId: string, options?: ICrudFetchOptions) => {
  const source = CrudStore.get<IToolAccessPartnerFlagsView>(
    CrudStoreItem.ToolAccessPartnerFlags,
    options?.cacheKey
  )

  source.setPaging({
    page: 0,
    pageSize: 1000,
  })

  source.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
    ],
  })

  return source
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then(({ items }: { items: IToolAccessPartnerFlagsView[] }) => {
      if (items) {
        return items.map(
          (item): IToolAccessConditions => ({
            flag: item.Flag,
            partnerId: item.PartnerId,
            uniqueId: item.UniqueId,
            comment: item.Comment,
            conditionFulfilled: item.ConditionFullfilled,
          })
        )
      }
      return []
    })
    .catch((error) => {
      Logger.error('fetchToolAccessConditions', error)
      return []
    })
}
